<template>
  <div class="home col-5 mx-auto py-5 mt-5" id="login-content">
    <h1 class="text-center">Acceder</h1>
    <div class="card">
      <div class="card-body">
        <div class="form-group">
          <label for="email">Correo electronico:</label>
          <input
            type="email"
            v-model="form.email"
            class="form-control"
            id="email"
          />
          <span class="text-danger" v-if="errors.email">
            {{ errors.email[0] }}
          </span>
        </div>
        <div class="form-group">
          <label for="password">Contraseña:</label>
          <input
            type="password"
            v-model="form.password"
            class="form-control"
            id="password"
          />
          <span class="text-danger" v-if="errors.password">
            {{ errors.password[0] }}
          </span>
        </div>
        <button @click.prevent="login" class="btn btn-primary btn-block">
          Acceder
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import User from "../apis/User";

export default {
  data() {
    return {
      form: {
        email: "",
        password: ""
      },
      errors: [],
      data: null
    };
  },

  methods: {
    login() {
      User.login(this.form)
        .then(result => {
          let data = result.data;
          console.log("Login datos recibiddos");
          console.log(data);
          if (Object.prototype.hasOwnProperty.call(data, "token")) {
            localStorage.setItem("token", data.token);
            // this.$store.commit("setToken", result.data.token);
            this.$root.$emit("login", true);
            this.$router.push({ name: "Dashboard" });
            this.$store.commit("load");
          }
        })
        .catch(error => {
          console.log("Error:");
          console.log(error);
          if (error.response.status === 422) {
            this.errors = error.response.data.errors;
          }
        });
    }
  }
};
</script>
